import axios from '@/js/lib/axios';
import { updateToken } from '@/js/lib/api/update_token';

export const EmailNotificationSettingId = {
  SUBSCRIBE_DAILY_PRODUCT_REQUEST: 310, // 再出品リクエストの日別通知を受け取るかどうか
  SUBSCRIBE_EVENT_REMINDER: 304, // お気に入りしたイベントのリマインダー
  SUBSCRIBE_FOLLOW_MAIL: 301, // フォローメールを受け取るか
  SUBSCRIBE_ITEMS_IN_CART: 305, // カゴ落ちメールを受け取るか
  SUBSCRIBE_LIKED_MAIL: 302, // お気に入りされましたメールを受け取るか
  SUBSCRIBE_MESSAGE_RECEIVING_EMAIL: 111, // メッセージ受信メールを受け取るか
  SUBSCRIBE_NEWSLETTER: 303, // iichi通信を受け取るかどうか
  SUBSCRIBE_NURTURING: 311, // サポートメールを受け取るか
  SUBSCRIBE_OTHER_MAILS: 309, // その他のお知らせメールを受け取るか
} as const;
export type EmailNotificationSettingId = (typeof EmailNotificationSettingId)[keyof typeof EmailNotificationSettingId];

export const PushNotificationSettingId = {
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_TRADING_ACTIVITIES: 401, // 取引関連のプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_MESSAGE_RECEIVING: 402, // メッセージ受信のプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_FOLLOWEES_ACTIVITIES: 403, // フォロー中のショップのアクティビティのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_REQUESTING_ITEM_RESTOCKED: 404, // リクエストした商品が再入荷したときのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_EVENT_ACTIVITIES: 405, // イベントのアクティビティのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_REMINDING_ITEMS_IN_CART: 406, // カゴ落ち商品のリマインダーのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_CONTENTS: 407, // コンテンツのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_INFORMATIONS: 408, // お知らせのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_ITEM_LIKED: 451, // お気に入りされた商品のプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_FOLLOWED: 452, // フォローされたときのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_EVENT_LIKED: 453, // お気に入りされたイベントのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_RESTOCK_REQUESTED: 454, // 再入荷リクエストされたときのプッシュ通知を受け取るか
  SETTING_PUSH_NOTIFICATION_SUBSCRIBE_SHOP_SUPPORTS: 455, // ショップサポートのプッシュ通知を受け取るか
} as const;
export type PushNotificationSettingId = (typeof PushNotificationSettingId)[keyof typeof PushNotificationSettingId];

export type NotificationSettingId = EmailNotificationSettingId | PushNotificationSettingId;

export const getNotificationStatus = async (settingId: NotificationSettingId): Promise<{ subscribed: boolean }> => {
  const res = await axios.get('/api/my/setting/notification', {
    params: {
      setting_id: settingId,
    },
  });

  return res.data;
};

export const setNotificationStatus = async (settingId: NotificationSettingId, subscribed: boolean): Promise<''> => {
  const token = await updateToken();
  const res = await axios.post('/api/my/setting/notification', {
    setting_id: settingId,
    subscribed,
    token,
  });
  return res.data;
};
